import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    board: '',
    // IP: '157.230.111.123',
    IP: '157.230.111.109',
    API_PORT: '48151',
    IMG_PORT: '8083',
    PROTOCOL: 'http'
  },
  mutations: {
    board (state, component) {
      state.board = component
    },
    IP (state, host) {
      state.IP = host
    }
  }
})



// WEBPACK FOOTER //
// ./src/store.js